var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE__frontend_js_react_web_liferay_exports_classnames_js_5caf4cf4__;